module.exports = __webpack_public_path__ + "img/Editsaina.892ed187.svg";